import { useSelector } from 'react-redux';

import UserPermissionTypes from '@constants/permissions';
import { LOCAL_STORAGE_KEYS } from '@constants/storage';
import useCheckPermission from '@hooks/checkPermission';
import { getLocalStorageItem } from '@utils/storage';

/** Matches backend AuthorizeOrganisationPermissions for dashboard APIs. */
const useCanAccessDashboardApis = () => {
  const { checkPermission } = useCheckPermission();
  const { currentOrg, permissionsOrganisationId, rolesAndPermissions } =
    useSelector((state: any) => state.user);

  const organizationId =
    currentOrg?.id || getLocalStorageItem(LOCAL_STORAGE_KEYS.ORGANIZATION_ID);

  // Permissions still belong to a previous org until AccessGuard finishes.
  if (
    !organizationId ||
    permissionsOrganisationId !== organizationId ||
    !rolesAndPermissions?.permissions
  ) {
    return false;
  }

  return checkPermission([
    UserPermissionTypes.DASHBOARD_VIEW,
    UserPermissionTypes.ORG_DASHBOARD_VIEW
  ]);
};

export default useCanAccessDashboardApis;
